import React from 'react';
import IEmptyProps from "EmptyProps";
import IEmptyState from "EmptyState";

export default class Footer extends React.Component<IEmptyProps, IEmptyState> {
    constructor(props: IEmptyProps) {
        super(props);
    }

    public render() {
        return (
            <footer>
                <div className="container">
                    <div>v4.140.0 © {new Date().getFullYear()} La Barak. Tous droits réservés. Conception par <a
                        href="https://www.facebook.com/olivier.robert.944" target="_blank">Olivier Robert</a></div>
                </div>
            </footer>
        );
    }
}